import React, { Fragment } from 'react';
import './RelatedContents.scss';
import relatedContentsData from './relatedContentsData';

function RelatedContents() {
  const currentUrl = window.location.href;
  return (
    <section className="relatedContents">
      <div className="relatedContents__tiles">
        {relatedContentsData.map((data, i) => {
          return (
            <Fragment key={data.content}>
              {currentUrl !== data.url ? (
                <div
                  className={
                    relatedContentsData[i + 1]
                      ? i === 0
                        ? `relatedContents__tile relatedContents__tile-${data.content} relatedContents__tile-first`
                        : `relatedContents__tile relatedContents__tile-${data.content}`
                      : `relatedContents__tile relatedContents__tile-${data.content} relatedContents__tile-last`
                  }
                  key={i}
                >
                  <div className="relatedContents__tile--overlay relatedContents__tile--contents" />
                  <div className="relatedContents__tile--contents relatedContents__tile__content">
                    <p className="relatedContents__tile__title">{data.title}</p>
                    <p className="relatedContents__tile__body">{data.body}</p>
                    <a className="relatedContents__tile__button" href={data.url} target="_blank" rel="sponsored">
                     {data.button}
                    </a>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </Fragment>
          );
        })}
      </div>
    </section>
  );
}

export default RelatedContents;
